<template>
  <div class="product-in-cart-card-wrapper">
    <img :src="item?.product?.thumbnail" alt="product" class="product">
    <div class="detail-wrapper">
      <p class="title">{{ item?.product.name }}</p>
      <div class="price-row">
        <p class="price">฿{{ unitPrice }}</p>
        <template v-if="hasDiscount">
          <span class="original-price">฿{{ item?.product.price }}</span>
          <span class="discount-percent">-{{ item?.product.discount_percent }}%</span>
        </template>
      </div>
    </div>
    <div class="amount"><small>X</small> {{ amount }}</div>
  </div>
</template>

<script>
import { computed, ref } from 'vue'

export default {
  props: {
    item: {
      type: Object,
      default: null,
    }
  },
  setup(props) {

    /** reactive */
    const amount = ref(props.item?.amount)

    /** computed */
    const hasDiscount = computed(() => !!props.item?.product?.is_discount_active)
    const unitPrice = computed(() => (
      props.item?.product?.effective_price ?? props.item?.product?.price
    ))

    return {
      amount,
      hasDiscount,
      unitPrice,
    }
  }
}
</script>

<style lang="scss" scoped>
.product-in-cart-card-wrapper {
  border: 1px solid #C3C3C3;
  padding: 8px 12px;
  border-radius: 6px;
  display: flex;
}

img.product {
  height: 32px;
  width: 32px;
  border-radius: 6px;
}

.detail-wrapper {
  margin-left: 12px;
}

.title {
  font-size: 20px;
}

.price-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.price {
  color: var(--error-color);
  font-size: 20px;
  font-weight: bold;
}

.original-price {
  font-size: 16px;
  color: #9A9A9A;
  text-decoration: line-through;
}

.discount-percent {
  font-size: 12px;
  font-weight: bold;
  color: #FD6868;
  border: 1px solid #FD6868;
  border-radius: 3px;
  padding: 1px 4px;
  white-space: nowrap;
}

.amount {
  margin-left: auto;
  > small {
    font-size: 0.8em;
  }
}

</style>
